export default "__VITE_PUBLIC_ASSET__990e46b7__"